export enum Theme {
    Light = "light",
    Dark = "dark",
}

export enum UserRole {
    CEO = "ceo",
    CTO = "cto",
    SeniorFrontendEngineer = "senior_frontend_engineer",
    FrontendEngineer = "frontend_engineer",
    SeniorBackendEngineer = "senior_backend_engineer",
    AIEngineer = "ai_engineer",
    QualityControl = "quality_control",
    ProjectManager = "project_manager",
    HRManager = "hr_manager",
    DataAnalyst = "data_analyst",
    UIUXDesigner = "uiux_designer",
}

export enum SprintStatus {
    Active = "active",
    Completed = "completed",
    Planned = "planned",
}
